import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import './css/font-awesome.min.css';
import './css/style.css';
import './css/bootstrap.min.css';
import './css/font-awesome.min.css';
import jQuery from './js/jquery.js';
import { Header } from './component/home/header/header.component';
import Home from './component/home/home.component';
import { YoutubeLinks } from './component/home/youtube-links/youtube-links.component';
import Footer from './component/home/footer/footer.component';
import { WhyUs } from './component/home/whyus/why-us.component';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
	<App></App>

	{/* preloader */}
	<div id='preloader'><div className='preloader'>
		<img className="loader-logo" src={require('./img/loader-logo.png')}></img>
	</div></div> 
	{/* /preloader */}
  </React.StrictMode>
  
);


(function($) {
	"use strict"
	
	// Preloader
	$(window).on('load', function() {
		$("#preloader").delay(600).fadeOut();
		setTimeout(()=>{
			$("#preloader").hide();
		}, 2000)
	});

	// Mobile Toggle Btn
	$('.navbar-toggle').on('click',function(){
		$('#header').toggleClass('nav-collapse');
	});
	
})(jQuery);